import { render, staticRenderFns } from "./trialBalanceArchiveList.vue?vue&type=template&id=4cfec524&scoped=true"
import script from "./trialBalanceArchiveList.vue?vue&type=script&lang=js"
export * from "./trialBalanceArchiveList.vue?vue&type=script&lang=js"
import style0 from "./trialBalanceArchiveList.vue?vue&type=style&index=0&id=4cfec524&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfec524",
  null
  
)

export default component.exports